import { render, staticRenderFns } from "./KvModal.vue?vue&type=template&id=77fe3b28&"
import script from "./KvModal.vue?vue&type=script&lang=js&"
export * from "./KvModal.vue?vue&type=script&lang=js&"
import style0 from "./KvModal.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77fe3b28')) {
      api.createRecord('77fe3b28', component.options)
    } else {
      api.reload('77fe3b28', component.options)
    }
    module.hot.accept("./KvModal.vue?vue&type=template&id=77fe3b28&", function () {
      api.rerender('77fe3b28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/kiva/KvModal.vue"
export default component.exports